// © 2013 - 2024 Tinder, Inc., ALL RIGHTS RESERVED

import React, { memo } from 'react';
import { IconProps as Props } from '../types';

const SvgEducationOutline: React.FC<Props> = (allProps) => {
  const { fill, primary, secondary, tertiary, quaternary, ...props } = allProps;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={24}
      height={24}
      viewBox="0 0 24 24"
      focusable="false"
      aria-hidden="true"
      role="presentation"
      {...props}
    >
      <g fill={primary ?? fill ?? 'currentColor'}>
        <path
          fillRule="evenodd"
          d="M11.171 4.182a1.975 1.975 0 0 1 1.658 0l10.578 4.883c.79.365.79 1.505 0 1.87L20 12.507v4.903a2 2 0 0 1-1.02 1.744l-.607.341a13 13 0 0 1-12.746 0l-.608-.341A2 2 0 0 1 4 17.41v-4.902l-1-.462V14a1 1 0 1 1-2 0v-2.877l-.407-.188c-.79-.365-.79-1.505 0-1.87zm1.658 11.636 4.848-2.238H18v3.83l-.607.342a11 11 0 0 1-10.786 0L6 17.41v-3.83h.323l4.848 2.238a1.977 1.977 0 0 0 1.658 0M20.593 10 12 6.033 3.406 10 12 13.967z"
          clipRule="evenodd"
        />
      </g>
    </svg>
  );
};

const Memo = memo(SvgEducationOutline);
export default Memo;
